import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

/* ============================================================
   AVISO DOS VENCIMENTOS — valores José Tripa introduzidos

   Para o Tiago (pedido de 22-09-2026): quando um mês tem mais de 5 valores José
   Tripa introduzidos, a barra lateral mostra um número em Recursos Humanos — há
   valores prontos para o processamento dos salários. O servidor decide quem vê
   (só a conta do Tiago) e quais os meses; desliga-se nos Vencimentos.

   Mesmo padrão dos alertas das viaturas: sem polling, recarrega quando o
   separador volta a ficar visível ou ganha foco.
   ============================================================ */

const AvisoVencimentosContext = createContext({ total: 0, pendentes: [], recarregar: () => {} });

export const useAvisoVencimentos = () => useContext(AvisoVencimentosContext);

export const AvisoVencimentosProvider = ({ children }) => {
    const { isAuthenticated, loading: authLoading, user } = useAuth();
    const [estado, setEstado] = useState({ total: 0, pendentes: [] });

    // Os vencimentos são só de administradores: os outros nem perguntam.
    const podeConsultar = !authLoading && isAuthenticated && user?.role === 'admin';

    const buscar = useCallback(async () => {
        if (!podeConsultar) return;
        try {
            const r = await api.get('/rh/vencimentos/aviso', { params: { _t: Date.now() } });
            setEstado({ total: r.data?.total || 0, pendentes: r.data?.pendentes || [] });
        } catch {
            // indicador acessório: nunca interrompe o que o utilizador está a fazer
        }
    }, [podeConsultar]);

    useEffect(() => {
        if (!podeConsultar) { setEstado({ total: 0, pendentes: [] }); return; }
        buscar();
        const aoVoltar = () => { if (document.visibilityState === 'visible') buscar(); };
        document.addEventListener('visibilitychange', aoVoltar);
        window.addEventListener('focus', aoVoltar);
        return () => {
            document.removeEventListener('visibilitychange', aoVoltar);
            window.removeEventListener('focus', aoVoltar);
        };
    }, [podeConsultar, buscar]);

    return (
        <AvisoVencimentosContext.Provider value={{ ...estado, recarregar: buscar }}>
            {children}
        </AvisoVencimentosContext.Provider>
    );
};
